import Vue from 'vue';

import _jwtDecode from 'jwt-decode';

import { AUTH_AUTOLOGIN, AUTH_LOGIN, AUTH_LOGOUT } from '../actions/auth';
import userApi from '@/api/user';

/* eslint-disable camelcase */


function defaultState () {
  return {
    raw_token: '',

    data: {
      username: '',
      role: '',
      entity_id: null
    }
  };
}


function jwtDecode (token) {
  const jwt = _jwtDecode(token);
  if (jwt.exp) {
    const now = Math.floor(Date.now() / 1000);
    if (now > jwt.exp) {
      throw new Error('Token is expired');
    }
  }

  return jwt;
}

// eslint-disable-next-line no-unused-vars
function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const getters = {
  isAuthenticated: state => !!state.data.username,

  hasRole: state => (r) => {
    if (!r) {
      return true;
    }

    let candidates;
    if (Array.isArray(r)) {
      candidates = r;
    } else {
      candidates = [r];
    }

    return candidates.includes(state.data.role);
  },
  hasPermission: state => (role, id) => {
    if (state.data.role === 'admin') {
      return true;
    }

    if (state.data.role === role && state.data.entity_id === id) {
      return true;
    }

    return false;
  }
};

const actions = {
  async [AUTH_AUTOLOGIN] ({ commit }) {
    const raw_token = localStorage.getItem('user-token') || '';
    const data = jwtDecode(raw_token);

    commit(AUTH_LOGIN, { raw_token, data });
  },
  async [AUTH_LOGIN] ({ commit }, { username, password }) {
    const response = await userApi.login({ username, password });

    const raw_token = response.token;
    const data = jwtDecode(raw_token);

    commit(AUTH_LOGIN, { raw_token, data });
  },
  async [AUTH_LOGOUT] ({ commit }) {
    commit(AUTH_LOGOUT);
  }
};

const mutations = {
  [AUTH_LOGIN] (state, { raw_token, data }) {
    state.raw_token = raw_token;
    state.data = Object.assign({}, state.data, data);

    // Set the token into Local Storage
    localStorage.setItem('user-token', raw_token);

    // Set axios header
    Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${raw_token}`;
  },
  [AUTH_LOGOUT] (state) {
    Object.assign(state, defaultState());

    // Remove the token from Local Storage
    localStorage.removeItem('user-token');

    // Remove axios header
    delete Vue.axios.defaults.headers.common['Authorization'];
  }
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
